import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-6" data-testid="not-found-page">
      <h1 className="text-6xl font-display font-bold text-celestial-text mb-3">404</h1>
      <p className="text-celestial-muted mb-8">This page doesn't exist in the admin panel.</p>
      <Button asChild className="btn-celestial rounded-full px-6 py-2.5">
        <Link to="/" data-testid="go-home-btn">
          <Home className="w-4 h-4 mr-2" />
          Back to admin
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
